var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoProfileGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_plane-copy-icons/24x24/ico_person",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98009507,12.8283571 L2.68657176,12.5049762 C2.71131167,12.4060166 2.75758455,12.2440615 2.82587789,12.0391815 C2.93933913,11.6987978 3.0757148,11.3578586 3.23704862,11.0351909 C3.7561845,9.99691916 4.41977032,9.33333333 5.33333338,9.33333333 L10.6666666,9.33333333 C11.5802297,9.33333333 12.2438155,9.99691916 12.7629514,11.0351909 C12.9242852,11.3578586 13.0606609,11.6987978 13.1741221,12.0391815 C13.2424154,12.2440615 13.2886883,12.4060166 13.3134282,12.5049762 L12.0199049,12.8283571 C12.0029782,12.7606501 11.9659177,12.6309385 11.9092111,12.4608185 C11.814339,12.1762022 11.7007147,11.8921414 11.5703818,11.6314757 C11.2561844,11.0030808 10.9197702,10.6666667 10.6666666,10.6666667 L5.33333338,10.6666667 C5.0802298,10.6666667 4.74381563,11.0030808 4.42961819,11.6314757 C4.29928535,11.8921414 4.18566102,12.1762022 4.09078893,12.4608185 C4.03408227,12.6309385 3.99702182,12.7606501 3.98009507,12.8283571 Z M11.0000002,5.66666667 C11.0000002,7.35729611 9.65873333,8.66666667 7.97293349,8.66666667 C6.29319477,8.66666667 5.00000016,7.36288535 5.00000016,5.66666667 C5.00000016,3.95351461 6.25550049,2.66666667 7.97293349,2.66666667 C9.69626183,2.66666667 11.0000002,3.95990391 11.0000002,5.66666667 Z M9.66666667,5.66666667 C9.66666667,4.69870816 8.962285,4 7.97293333,4 C6.99933967,4 6.33333333,4.68263534 6.33333333,5.66666667 C6.33333333,6.62892818 7.03201872,7.33333333 7.97293333,7.33333333 C8.92944016,7.33333333 9.66666667,6.61363859 9.66666667,5.66666667 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfileGray);
export default __webpack_public_path__ + "static/media/ico_profile_gray.0c9de13f26d5f143b395ae881b038d94.svg";
export { ForwardRef as ReactComponent };